export var GOOGLE_IMA_CLIENT_SIDE_PLUGIN_ID="@dicetechnology/doris-plugin-google-ima-client-side";